export default {"src":"/_next/static/media/modern_visa.1df017e9.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};